// -- import * as _ from "lodash-es"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = ""

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = {
  default: [
    {
      key: "ForecastSalesId",
      label: "预测订单编码",
      sortable: true,
      width: "100px"
    },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true,
      width: "80px"
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      width: "8rem",
      sortable: true,
      thStyle: { width: "8rem" },
      type: "short"
    },
    {
      key: "CustAccountId",
      label: "客户账户",
      sortable: true,
      width: "80px"
    },
    {
      key: "CustAccountName",
      label: "客户名称",
      sortable: true,
      thStyle: { width: "10rem" },
      type: "short"
    },
    {
      key: "seq",
      label: "行号",
      sortable: true,
      width: "40px"
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "fcGetSFDispatchApprover",
      label: "待审批人",
      sortable: true,
      formatter: (value, key, item) => {
        if (
          !_.isNull(item.fcGetSFDispatchApprover) &&
          item.fcGetSFDispatchApprover
        ) {
          return item.fcGetSFDispatchApprover.split(",")[0]
        } else {
          return ""
        }
      }
    },
    {
      key: "fcCheckSFDApproved",
      label: "审批",
      sortable: true,
      type: "state",
      state_control: "fcCheckSFDApproved",
      other_type_key: "is_email_send",
      context: ["待审批", "已审批", "审批中"]
    },
    {
      key: "SFDApprovedState",
      label: "审批状态名称",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId",
      formatter: (value, key, item) => {
        if (item.fcCheckSFDApproved) {
          item.SFDApprovedState = "已审批"
          return "已审批"
        } else if (item.is_email_send) {
          item.SFDApprovedState = "审批中"
          return "审批中"
        } else {
          item.SFDApprovedState = "待审批"
          return "待审批"
        }
      }
    },
    {
      key: "SalesQty",
      label: "订单数量",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "qty",
      label: "派发数量",
      type: "number",
      _precise: 6
    },
    {
      key: "valid_remain",
      label: "剩余派发数量",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "SalesUnitId",
      label: "单位",
      sortable: true
    },
    {
      key: "Currency",
      label: "币种",
      sortable: true
    },
    {
      key: "SEI_DimensionFG",
      label: "FG维度",
      sortable: true
    },
    {
      key: "is_invent_ready",
      label: "备料",
      sortable: true,
      type: "boolean"
    },
    {
      key: "StartDate",
      label: "装运日期",
      sortable: true,
      type: "date"
    },
    {
      key: "is_cancel",
      label: "是否取消",
      sortable: true,
      type: "boolean"
    },
    {
      key: "AccountNum",
      label: "供应商编号",
      sortable: true
    },
    {
      key: "SEI_Name",
      label: "供应商名称",
      sortable: true,
      thStyle: {
        width: "11rem"
      }
    },
    {
      key: "ModelId",
      label: "预测模型"
    },
    {
      key: "SEI_ForecastSalesType",
      label: "预测类型",

      type: "textarea"
    },

    {
      key: "delivery_date",
      label: "装运日期",

      type: "date"
    },
    {
      key: "Capacity",
      label: "产能(天)",

      type: "number"
    },
    {
      key: "RetailVariantId",
      label: "变形编号",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId"
    },
    {
      key: "SEI_CP_ReplenishmentCommit",
      label: "补货计划"
    },
    {
      key: "WeekName",
      label: "周的名称"
    },
    {
      key: "TotalScore",
      label: "评价",
      sortable: true,
      type: "rate",
      disabled: true,
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "create_by",
      label: "创建人",
      sortable: true
    },
    {
      key: "create_at",
      label: "创建时间",
      type: "datetime"
    },
    {
      key: "sf_create_by_username",
      label: "派发创建人",
      sortable: true
    },
    {
      key: "update_by",
      label: "修改人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.update_by_username
      }
    },
    {
      key: "update_at",
      label: "修改时间",
      sortable: true,
      type: "datetime"
    }
  ]
}

///前端验证
const rules = {}

const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)
const methods = {
  async getData(_params) {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "get_sf_item_dispatch",
      {},
      {}
    )
    let _fields = []

    let result = await code_biz_data
      .execAction({
        params: _params,
        fields: _fields
      })
      .run()
    //
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  }
}
export { biz_data, fields, methods, rules };

